import { lazy, useState, useEffect, useCallback } from "react";
import "./App.css";
import AppThemeProvider from "AppThemeProvider";
import { Icon, IconButton } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { notistackRef } from "constants/RefConstants";
import Suspense from "common/Suspense";
import useAuthUser from "hooks/useAuthUser";

function App() {

  // Track authentication state
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('ledgeflow_token'));

  // Sync with localStorage on mount and when storage changes
  useEffect(() => {
    const syncAuth = () => {
      setIsAuthenticated(!!localStorage.getItem('ledgeflow_token'));
    };
    window.addEventListener('storage', syncAuth);
    return () => window.removeEventListener('storage', syncAuth);
  }, []);

  // Callback to set auth after login
  const handleLogin = useCallback(() => {
    setIsAuthenticated(true);
  }, []);

  // Callback to logout
  const handleLogout = useCallback(() => {
    localStorage.removeItem('ledgeflow_token');
    setIsAuthenticated(false);
  }, []);

  return (
    <AppThemeProvider>
      <SnackbarProvider
        ref={notistackRef}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        preventDuplicate
        action={(key) => (
          <IconButton
            onClick={() => {
              notistackRef.current.closeSnackbar(key);
            }}
            color="inherit"
            size="small"
          >
            <Icon>close</Icon>
          </IconButton>
        )}
      >
        <Suspense>
          {isAuthenticated ? (
            <AppProtected onLogout={handleLogout} />
          ) : (
            <AppPublic onLogin={handleLogin} />
          )}
        </Suspense>
      </SnackbarProvider>
    </AppThemeProvider>
  );
}

export default App;

const AppPublic = lazy(() => import("./AppPublic"));
const AppProtected = lazy(() => import("./AppProtected"));
